import Sidebar from "../component/Sidebar";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import API from "../services/api";
import { useEffect, useState } from "react";
import {
  logout,
  getAuthUser,
  setAuthToken,
  clearAuthUser,
} from "../services/auth";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(() => getAuthUser());

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout();
      navigate("/login");
    } catch (err) {
      console.error(err);
      toast.error(
        "Logout gagal: " + (err.response?.data?.message || "Terjadi kesalahan")
      );
    }
  };

  const getPageTitle = () => {
    if (location.pathname.includes("/dashboard")) return "Dashboard";
    if (location.pathname.includes("/leads")) return "Database Dinas";
    if (location.pathname.includes("/user")) return "User";
    if (location.pathname.includes("/databaseVendor")) return "Database Vendor";
    if (location.pathname.includes("/tutorial")) return "Tutorial";
    // if (location.pathname.includes("/databaseLeads")) return "Leads";
    return "Dashboard";
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      clearAuthUser();
      setUser(null);
      return;
    }

    API.get("/me")
      .then((res) => {
        localStorage.setItem("auth", JSON.stringify(res.data));
        setUser(res.data);
      })
      .catch((err) => {
        clearAuthUser();
        setUser(null);
        navigate("/login");
      });
  }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1 main-content">
        <nav className="navbar navbar-expand bg-light shadow-sm px-3">
          <div className="container-fluid ms-3">
            <span className="navbar-brand fs-4 fw-semibold text-dark">
              {getPageTitle()}
            </span>
            <div className="dropdown ms-auto">
              <button
                className="btn btn-light d-flex align-items-center gap-2 rounded px-3 py-2 shadow dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-person-circle fs-5"></i>
                <span className="fw-medium">
                  {user
                    ? `Hai, ${
                        user.name.length > 8
                          ? user.name.slice(0, 7) + "..."
                          : user.name
                      }`
                    : "Memuat..."}
                </span>
              </button>

              <ul className="dropdown-menu dropdown-menu-end">
                <li className="d-flex align-items-center mx-3 ">
                  <div
                    className="rounded-circle bg-secondary d-flex justify-content-center align-items-center me-2"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i className="fa-solid fa-user text-white"></i>
                  </div>
                  <div>
                    <div className="fw-semibold w-100">{user?.name}</div>
                    <div className="text-muted small">{user?.email}</div>
                  </div>
                </li>
                <hr className="my-2" />
                <li>
                  <Link
                    to="/profile/changepassword"
                    className="dropdown-item d-flex align-items-center"
                  >
                    Reset Password
                  </Link>
                </li>

                <hr className="my-2" />
                <li>
                  <button
                    className="dropdown-item d-flex align-items-center text-danger"
                    onClick={handleLogout}
                  >
                    <i className="fa-solid fa-arrow-right-from-bracket me-2"></i>{" "}
                    Log out
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <main className="p-4">
          <Outlet />
        </main>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AppLayout;
